import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, Subject} from 'rxjs';
import {LeadResponse} from '../model/lead-response.model';

@Injectable({
  providedIn: 'root'
})
export class LeadService {

  private LEAD_PATH: string = '/api/leadsourceservice/v1/lead-sources/{leadSourceId}/leads';

  constructor(private httpClient: HttpClient) {
  }

  public postLead(leadSourceId: string, payload: FormData): Observable<LeadResponse>{
    this.moveMilesAndMoreServiceNumberToRemarksField(payload);
    return  this.httpClient
          .post<LeadResponse>( this.LEAD_PATH.replace('{leadSourceId}', leadSourceId),
            payload);
  }

  private moveMilesAndMoreServiceNumberToRemarksField(payload: FormData) {
    if (payload.get('mainApplicant_milesAndMoreServiceNumber') != null) {
      payload.set('remarks', `${payload.get('remarks')} || Miles & More Servicekartennummer: ${payload.get('mainApplicant_milesAndMoreServiceNumber')}`)
      payload.delete('mainApplicant_milesAndMoreServiceNumber');
    }
  }
}
